import { ListaMarcas, ListaModelos } from './../../../../../_entities/dispositivos/AgregarDispositivoVM';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModeloDispositivoService } from './../../../services/modelo-dispositivo.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-alta-modelo-dispositivo',
  templateUrl: './alta-modelo-dispositivo.component.html',
  styleUrls: ['./alta-modelo-dispositivo.component.scss']
})
export class AltaModeloDispositivoComponent implements OnInit {
  public marcasDispositivo: ListaMarcas[];
  public loading: boolean = false;
  public modeloForm: FormGroup;
  public param: any;
  public idModelo: any;

  constructor(private modeloDispositivoService: ModeloDispositivoService,
    private toastService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
    this.obetenerMarcas();
    this.param = this.activatedRoute.params.subscribe(
      param => {
        this.idModelo = param['idModelo'];
        if (this.idModelo) {
          this.obtenerModelo(this.idModelo);
        }
      }
    );
  }

  initForm(){
    this.modeloForm = this.fb.group({
      Id: [0],
      Nombre: [''],
      IdMarca: ['']
    })
  }

  obetenerMarcas() {
    this.modeloDispositivoService.obtenerMarcas().subscribe(
      (res: ListaMarcas[]) => {
        this.marcasDispositivo = res;
    },(err)=>{this.toastService.error('Ocurrio un error al consultar las marcas')});
  }

  obtenerModelo(idModelo: any) {
    this.modeloDispositivoService.obtenerModelo(idModelo).subscribe((res: ListaModelos)=>{
      this.modeloForm.setValue({
        Id: res.id,
        Nombre: res.nombre,
        IdMarca: res.idMarca
      });
    },err=>{this.toastService.error('Ocurrio un error al consultar la información del modelo')});
  }

  onSubmit(){
    if(this.idModelo){
      this.modeloDispositivoService.actualizarModelo(this.modeloForm.value).subscribe((res)=>{
        this.toastService.success('Se Actualizo el modelo correctamente','Bien hecho');
      },(err)=>{
          this.toastService.error('Ocurrio un erro al actualizar el modelo')
          this.router.navigateByUrl('home/administracion/modelo');
      },
      () => this.onSubmitComplete());
    }else{
      this.modeloDispositivoService.agregarModelo(this.modeloForm.value).subscribe((res) =>{
        this.toastService.success('Se guardo el modelo correctamente','Bien hecho');
        this.modeloForm.reset();
        this.router.navigateByUrl('home/administracion/modelo');
      },(err)=>{this.toastService.error('Ocurrio un error al guardar el modelo')},
      () => this.onSubmitComplete());
    }
  }

  onCancel(){
    this.router.navigateByUrl('home/administracion/dispositivos/modelo');
  }
  onSubmitComplete() : void {
    this.loading = false;
  }
}
